import React, {
  Fragment,
  useEffect,
  useState
} from "react";
import {
  Button,
  Form,
  FormFeedback,
  FormGroup,
  FormText,
  Input,
  Label
} from "reactstrap";
import { connect } from "react-redux";
import Async from "react-select/async";
import { getOrganisationsForAsyncSelect } from "../../store/organisation/actions";
import { getUsersForAsyncSelect } from "../../store/actions";
import { assignDevices, clearAssignDeviceError, setAssignDevice } from "../../store/device/actions";
import { MANUFACTURER, SUPER_ADMIN } from "../../store/users/role.constants";
import UITooltip from "../../CommonData/Data/UITooltip";
import Message from "../../CommonData/Data/Message";
import { clearForm, updateForm } from "../../store/form/actions";
import VWLoading from "../../components/vwLoading/vwLoading";

const AssignDevice = (props) => {

  const { currentProfile, errorMessage, handleClose, form, isAssignPending } = props;
  const [selected_user, setSelectedUser] = useState("");
  const [new_user_organisation, setNewUserOrganisation] = useState("");

  const currentRole = currentProfile.roles && currentProfile.roles.length > 0 && currentProfile.roles[0]
  // const isSuperAdmin = currentProfile.roles && currentProfile.roles.length > 0 && currentProfile.roles[0].roleKey === SUPER_ADMIN;
  const isSuperAdmin = currentRole && currentRole.roleKey === SUPER_ADMIN;
  const isManufacturer = currentRole && currentRole.roleKey === MANUFACTURER;
  const highLevelRoles = isSuperAdmin || isManufacturer;

  useEffect(() => {
    if (!highLevelRoles) {
      setNewUserOrganisation({
        label: currentRole.orgName,
        value: currentRole.orgId,
      });
    }

    props.updateForm({
      formAssignDevice: {},
      errors: {}
    })

    props.clearAssignDeviceError();

    //--------------------Key-Listener----------------------
    const handleKeyPress = (e) => {
      if (e.key === "Escape") {
        handleClose();
      }
    };

    window.addEventListener('keydown', handleKeyPress);

    return () => {
      window.removeEventListener('keydown', handleKeyPress);
    };
  }, []);

  const validateOnChange = (event) => {
    const { name, value } = event.target;
    props.updateForm({
      formAssignDevice: {
        ...form.formAssignDevice,
        [name]: value
      },
      errors: {
        ...form && form.errors,
        [name]: null,
      }
    });

  };

  const handleLoadUsers = (inputValue, callback) => {
    const organisationId = new_user_organisation && new_user_organisation.value;
    if (organisationId) {
      props.getUsersForAsyncSelect(organisationId, inputValue, callback);
    }
    else {
      callback([]);
    }
  };

  const handleLoadOrganisation = (inputValue, callback) => {
    props.getOrganisationsForAsyncSelect(inputValue, callback);
  };

  const handleAssignDevuserOrgChange = (value) => {
    props.updateForm({
      formAssignDevice: {
        ...form.formAssignDevice,
        new_user_organisation: value,
        selected_user: null
      },
      errors: {
        ...form && form.errors,
        new_user_organisation: null,
      }
    });
    setNewUserOrganisation(value);
    setSelectedUser(null)

  };

  const handleAssignDevUserChange = (value) => {
    props.updateForm({
      formAssignDevice: {
        ...form.formAssignDevice,
        selected_user: value
      },
      errors: {
        ...form && form.errors,
        selected_user: null,
      }
    });
    setSelectedUser(value)
  };

  const handleAssignDevice = (e) => {
    e.preventDefault();
    const { formAssignDevice } = form || {};
    const { new_user_organisation, deviceKeys, selected_user } = formAssignDevice || {};

    const currentErrors = {};

    if (!new_user_organisation && highLevelRoles) {
      currentErrors.new_user_organisation = "Organization is required"
    }
    if (!deviceKeys) {
      currentErrors.deviceKeys = "Serial No. is required"
    }
    if (!selected_user) {
      currentErrors.selected_user = "User is required"
    }
    props.updateForm({
      formAssignDevice: {
        ...form.formAssignDevice,
      },
      errors: currentErrors,
    })
    if (Object.keys(currentErrors).length === 0) {
      props.assignDevices(form.formAssignDevice);
    }
  };

  return isAssignPending ? <VWLoading /> : (
    <Fragment>
      {errorMessage && (
        <Message
          type="danger"
          defaultMessage={errorMessage}
          baseClassName="alert"
        />
      )}
      <Form className="mb-3" name="formAssignDevice">
        {highLevelRoles && (
          <FormGroup>
            <Label>
              Organization Name<span className="text-danger">*</span>
            </Label>
            <Async
              autoFocus={highLevelRoles}
              openMenuOnFocus={highLevelRoles}
              styles={{
                control: (baseStyles) => ({
                  ...baseStyles,
                  borderColor: (form && form.errors && form.errors.new_user_organisation) ? 'red' : ""
                })
              }}
              id="new_user_organisation"
              name="new_user_organisation"
              placeholder="Select organization"
              isDisabled={!highLevelRoles}
              defaultOptions
              loadOptions={handleLoadOrganisation}
              onChange={handleAssignDevuserOrgChange}
              // value={highLevelRoles ? null : new_user_organisation}
              value={new_user_organisation}
            />
            {(form && form.errors && form.errors.new_user_organisation) &&
              <FormText sx={{ marginLeft: "10px" }}>
                <div className="text-danger">
                  {form && form.errors && form.errors.new_user_organisation}
                </div>
              </FormText>
            }
          </FormGroup>
        )}
        {((highLevelRoles && new_user_organisation) || !highLevelRoles) && (
          <FormGroup>
            <Label>
              Username<span className="text-danger">*</span>
            </Label>
            <Async
              autoFocus={!highLevelRoles}
              openMenuOnFocus={!highLevelRoles}
              styles={{
                control: (baseStyles) => ({
                  ...baseStyles,
                  borderColor: (form && form.errors && form.errors.selected_user) ? 'red' : ""
                })
              }}
              key={new_user_organisation.value}
              id="selected_user"
              name="selected_user"
              placeholder="Select user"
              defaultOptions
              loadOptions={handleLoadUsers}
              onChange={handleAssignDevUserChange}
              isDisabled={!new_user_organisation}
              value={selected_user}
            />
            {(form && form.errors && form.errors.selected_user) &&
              <FormText sx={{ marginLeft: "10px" }}>
                <div className="text-danger">
                  {form && form.errors && form.errors.selected_user}
                </div>
              </FormText>
            }
          </FormGroup>
        )}
        <FormGroup>
          <Label>
            Serial Numbers<span className="text-danger">* &nbsp;&nbsp;</span>
            <UITooltip
              content="Input methods: Range (x-y), Comma seperated (x,y), Single number x"
              id="addDeviceSerialNos"
              key="addDeviceSerialNos"
            >
              <i className="fas fa-info-circle"></i>
            </UITooltip>
          </Label>
          <Input
            type="textarea"
            size='sm'
            name="deviceKeys"
            placeholder="Eg. 3; 5-8; 6,9"
            onChange={validateOnChange}
            value={(form && form.formAssignDevice && form.formAssignDevice.deviceKeys) || ''}
            invalid={form && form.errors && form.errors.deviceKeys}
          />
          <FormFeedback>{form && form.errors && form.errors.deviceKeys}</FormFeedback>
          <FormText>
            <b>TIP :</b> You can add multiple devices by separating them with
            comma or specify hyphen for range.
            <br />
          </FormText>
        </FormGroup>
      </Form>
      <FormGroup>
        <Button
          className='me-2'
          // size='sm'
          color="success"
          onClick={handleAssignDevice}
        >Submit
        </Button>
        <Button
          // size='sm'
          color="danger"
          onClick={handleClose}
        >Cancel
        </Button>

      </FormGroup>
    </Fragment>
  );
}

const mapStateToProps = (state) => ({
  form: state.form.form,
  isAssignPending: state.device.isAssignPending,
  errorMessage: state.device.errorMessage,
  currentProfile: state.login.currentProfile,
});

const mapDispatchToProps = (dispatch) => ({
  updateForm: (AssignDevice) => dispatch(updateForm(AssignDevice)),
  clearForm: () => dispatch(clearForm()),
  setAssignDevice: (assignDevice) => dispatch(setAssignDevice(assignDevice)),
  clearAssignDeviceError: () => dispatch(clearAssignDeviceError()),
  getOrganisationsForAsyncSelect: (searchValue, callback) => dispatch(getOrganisationsForAsyncSelect(searchValue, callback)),
  getUsersForAsyncSelect: (organisationId, searchValue, callback) => dispatch(getUsersForAsyncSelect(organisationId, searchValue, callback)),
  assignDevices: (AssignDevice) => dispatch(assignDevices(AssignDevice)),
});

export default connect(mapStateToProps, mapDispatchToProps)(AssignDevice);
